module.exports = __webpack_public_path__ + "static/media/photo-01-cgv.b2a69de7.png";